import Table, { TableBody, TableColumn, TableHeader, TableHeaderColumn, TableRow } from '@rio-cloud/rio-uikit/Table';
import { FormattedMessage } from 'react-intl';
import {
    DEFAULT_BUYER_GROUPS_DESCRIPTION,
    DEFAULT_GROUPS_DESCRIPTION,
    DEFAULT_SUPPLIER_GROUPS_DESCRIPTION,
} from '../../../listelements/groups/defaultGroups';
import type { AccountType } from '../../../../../configuration/login/loginSlice';

type DefaultGroupDescription = {
    generalDescription: string;
    key: string;
    titleId: string;
};

const DEFAULT_CARRIER_GROUP_KEYS = new Set(['Fleet_Admin', 'Fleet_Users', 'Fleet_Driver', 'Custom']);

export const UserGroupExplanation = (props: { accountType?: AccountType }) => {
    let defaultGroups: Record<string, DefaultGroupDescription>;

    switch (props.accountType) {
        case 'SUPPLIER':
            defaultGroups = DEFAULT_SUPPLIER_GROUPS_DESCRIPTION;
            break;
        case 'BUYER':
            defaultGroups = DEFAULT_BUYER_GROUPS_DESCRIPTION;
            break;
        // case 'CARRIER':
        default:
            defaultGroups = DEFAULT_GROUPS_DESCRIPTION;
            break;
    }

    const rows = Object.values(defaultGroups);
    const defaultCarrierRows = rows.filter(group => DEFAULT_CARRIER_GROUP_KEYS.has(group.key));
    const specialCarrierRows = rows.filter(group => !DEFAULT_CARRIER_GROUP_KEYS.has(group.key));

    const renderTable = (tableRows: DefaultGroupDescription[]) => (
        <Table rowKey='id'>
            <TableHeader>
                <TableHeaderColumn columnKey='name' width={200}>
                    <FormattedMessage id={'groups.table.header.name'} />
                </TableHeaderColumn>
                <TableHeaderColumn columnKey='description'>
                    <FormattedMessage id={'groups.table.header.description'} />
                </TableHeaderColumn>
            </TableHeader>
            <TableBody>
                {tableRows.map(group => (
                    <TableRow id={group.key} key={group.key}>
                        <TableColumn columnKey='name'>
                            <div className='text-left text-bold'>
                                <FormattedMessage id={group.titleId} />
                            </div>
                        </TableColumn>
                        <TableColumn columnKey='description'>
                            <div className='text-left'>
                                <FormattedMessage id={group.generalDescription} />
                            </div>
                        </TableColumn>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    );

    return (
        <>
            <h4>
                <FormattedMessage id={'header.info.entities.usergroups.title'} />
            </h4>
            <div className='padding-top-10'>
                <FormattedMessage id={'header.info.entities.usergroups.linkText'} />{' '}
                <FormattedMessage id={'header.info.entities.usergroups.text'} />
            </div>
            <div className={'margin-bottom-20 padding-top-20'}>
                {props.accountType === 'CARRIER' || props.accountType === undefined ? (
                    <>
                        {renderTable(defaultCarrierRows)}
                        {specialCarrierRows.length > 0 ? (
                            <div className='margin-top-20'>
                                <h5 className='margin-bottom-10'>
                                    <FormattedMessage id={'header.info.entities.usergroups.specialGroups'} />
                                </h5>
                                {renderTable(specialCarrierRows)}
                            </div>
                        ) : null}
                    </>
                ) : (
                    renderTable(rows)
                )}
            </div>
        </>
    );
};
